// i18n
import 'src/locales/i18n';

// scroll bar
import 'simplebar-react/dist/simplebar.min.css';

// lightbox
import 'yet-another-react-lightbox/styles.css';
import 'yet-another-react-lightbox/plugins/captions.css';
import 'yet-another-react-lightbox/plugins/thumbnails.css';

// map
import 'src/utils/mapboxgl';
import 'mapbox-gl/dist/mapbox-gl.css';

// editor
import 'react-quill/dist/quill.snow.css';

// slick-carousel
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

// lazy image
import 'react-lazy-load-image-component/src/effects/blur.css';

// ----------------------------------------------------------------------

// @mui
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
// redux
import ReduxProvider from 'src/redux/redux-provider';
// routes
import Router from 'src/routes/sections';
// theme
import ThemeProvider from 'src/theme';
// hooks
import { useScrollToTop } from 'src/hooks/use-scroll-to-top';
// components
import ProgressBar from 'src/components/progress-bar';
import MotionLazy from 'src/components/animate/motion-lazy';
import SnackbarProvider from 'src/components/snackbar/snackbar-provider';
import { SettingsProvider, SettingsDrawer } from 'src/components/settings';
import { GoogleOAuthProvider } from '@react-oauth/google';
// auth
import { AuthProvider, AuthConsumer, useAuthContext } from 'src/auth/context/jwt';
import { useEffect } from 'react';
import { enqueueSnackbar } from 'notistack';



// eslint-disable-next-line import/no-named-as-default
import signalRService from './components/settings/drawer/signalR.service';
import { API_CONFIG } from './constants';



export default function App() {
  useScrollToTop();

  useEffect(() => {
    console.log('App mounted. Subscribing to SignalR notifications...');

    // Đăng ký callback notification
    const unsubscribe = signalRService.onNotification((notification) => {
      enqueueSnackbar(notification.title || 'Thông báo mới', {
        variant: 'info',
        autoHideDuration: 5000,
      });
    });

    // Cleanup khi App unmount (thường là không bao giờ xảy ra, nhưng là good practice)
    return () => {
      console.log('App unmounted. Unsubscribing from SignalR notifications...');
      unsubscribe();
    };
  }, []);
  function SignalRManager() {
    const { isAuthenticated, user } = useAuthContext(); // Lấy trạng thái đăng nhập

    useEffect(() => {
      const hubUrl = `https://samnft.vecoi.com/NotificationHub`;
      const token = user?.authenticateToken;

      // Chỉ kết nối khi đã đăng nhập và có token
      if (isAuthenticated && token) {
        console.log('User authenticated, attempting to connect to SignalR...');
        signalRService.initialize(hubUrl, token);
        signalRService.requestNotificationPermission(); // Yêu cầu quyền thông báo
      }

      return () => {
        if (!isAuthenticated) {
          signalRService.disconnect();
        }
      };
    }, [isAuthenticated, user]);

    return null;
  };
  const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID || 'YOUR_GOOGLE_CLIENT_ID';

  return (
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
      <AuthProvider>
        <ReduxProvider>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <SettingsProvider
              defaultSettings={{
                themeMode: 'light', // 'light' | 'dark'
                themeDirection: 'ltr', // 'rtl' | 'ltr'
                themeContrast: 'default', // 'default' | 'bold'
                themeLayout: 'vertical', // 'vertical' | 'horizontal' | 'mini'
                themeColorPresets: 'default', // 'default' | 'cyan' | 'purple' | 'blue' | 'orange' | 'red'
                themeStretch: false,
              }}
            >
              <ThemeProvider>
                <MotionLazy>
                  <SnackbarProvider>
                    <SettingsDrawer />
                    <ProgressBar />
                    <AuthConsumer>
                      <SignalRManager />
                      <Router />
                    </AuthConsumer>
                  </SnackbarProvider>
                </MotionLazy>
              </ThemeProvider>
            </SettingsProvider>
          </LocalizationProvider>
        </ReduxProvider>
      </AuthProvider>
    </GoogleOAuthProvider>
  );
}
